// set strict mode to true

(function ($) {
  const siteUrl = noefi_bundle_object.siteurl;
  // var themeUrl = siteUrl + "/wp-content/themes/bmtg";

  // Local Storage Test
  function localStorageTest() {
    const test = "test";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  // if local storage is available
  if (localStorageTest()) {
    // get html lang
    function get_locale() {
      const locale = $("html").attr("lang");
      return locale;
    }

    // language variables
    let merken = "Merken";
    let gemerkt = "Gemerkt";
    if (get_locale() !== "de" && get_locale() !== "de-DE") {
      merken = "Save";
      gemerkt = "Saved";
    }

    let favorites = [];
    favorites = JSON.parse(localStorage.getItem("favorites"));
    let existsInFavorites = false;

    let favoritesCount = 0;
    if (favorites) {
      favoritesCount = favorites.length;
      $(".favorite-count").text(` (${favoritesCount})`);
    }

    function like() {
      $(".user-favorites").attr({
        "aria-pressed": "true",
        "aria-label": gemerkt,
      });
      $(".star").addClass("star-liked");
      $(".merken").addClass("gemerkt").text(gemerkt);
      favoritesCount += 1;
      $(".favorite-count").text(` (${favoritesCount})`);
    }

    function unlike() {
      $(".user-favorites").attr({
        "aria-pressed": "false",
        "aria-label": merken,
      });
      $(".star").removeClass("star-liked");
      $(".merken").removeClass("gemerkt").text(merken);
      favoritesCount -= 1;
      $(".favorite-count").text(` (${favoritesCount})`);
    }

    // get data-title and url
    const favoritesId = $(".user-favorites").data("id");
    const favoritesTitle = $(".user-favorites").data("title");
    const favoritesUrl = $(".user-favorites").data("url");

    // Function to update button state based on whether it exists in favorites
    function updateButtonState(isFavorite) {
      if (isFavorite) {
        $(".user-favorites").attr({
          "aria-pressed": "true",
          "aria-label": gemerkt,
        });
        $(".star").addClass("star-liked");
        $(".merken").addClass("gemerkt").text(gemerkt);
      } else {
        $(".user-favorites").attr({
          "aria-pressed": "false",
          "aria-label": merken,
        });
        $(".star").removeClass("star-liked");
        $(".merken").removeClass("gemerkt").text(merken);
      }
    }

    // Initial check on page load
    if (favorites) {
      for (let i = 0; i < favorites.length; i++) {
        if (favorites[i].id === favoritesId) {
          existsInFavorites = true;
          break; // Exit loop once found
        }
      }
    }
    // Set initial button state based on whether it was found
    updateButtonState(existsInFavorites);

    // Update event handler for accessibility and star toggle
    // Consolidate click/keydown handling
    $(".user-favorites")
      .off("click keydown") // Remove previous handlers to prevent duplicates
      .on("click keydown", function (e) {
        if (
          e.type === "click" ||
          (e.type === "keydown" && (e.key === "Enter" || e.key === " "))
        ) {
          e.preventDefault();

          // Always read the latest state from localStorage inside the handler
          let currentFavorites =
            JSON.parse(localStorage.getItem("favorites")) || [];
          let isCurrentlyFavorite = false;

          for (let i = 0; i < currentFavorites.length; i++) {
            if (currentFavorites[i].id === favoritesId) {
              isCurrentlyFavorite = true;
              break;
            }
          }

          if (isCurrentlyFavorite) {
            // ---- UNLIKE LOGIC ----
            // Filter out the item
            const newFavorites = currentFavorites.filter(
              (item) => item.id !== favoritesId
            );
            // Update localStorage
            if (newFavorites.length === 0) {
              localStorage.removeItem("favorites");
            } else {
              localStorage.setItem("favorites", JSON.stringify(newFavorites));
            }
            // Update UI
            unlike();
          } else {
            // ---- LIKE LOGIC ----
            const newFavorite = {
              id: favoritesId,
              title: favoritesTitle,
              url: favoritesUrl,
              position: currentFavorites.length + 1, // Position based on current length
            };
            const newFavorites = [...currentFavorites, newFavorite];
            localStorage.setItem("favorites", JSON.stringify(newFavorites));
            // Update UI
            like();
          }
        }
      });
  }

  // The End of it All
})(jQuery);
